import {ExhibitorsViewStore} from './ExhibitorsViewStore';
import {ExhibitorsFilterStore} from './ExhibitorsFilterStore';

export class ExhibitorStore {
  constructor(rootStore) {
    this.view = new ExhibitorsViewStore(rootStore);
    this.filter = new ExhibitorsFilterStore(rootStore);
  }
}
